import { render, staticRenderFns } from "./LocaleToggle.vue?vue&type=template&id=36a877b0&"
import script from "./LocaleToggle.vue?vue&type=script&lang=js&"
export * from "./LocaleToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports